import { Component, Input } from "@angular/core";

@Component({
  selector: "app-loader",
  templateUrl: "./loader.component.html",
})
export class LoaderComponent {
  @Input() opacity = 1;

  get style() {
    return { opacity: this.opacity };
  }
}
